import { OrderFilterSetting } from "../../../../../types/order/orderQuery";

export function hasActiveFilters(filterSetting: OrderFilterSetting): boolean {
  return Object.values(filterSetting).some((filterValue) =>
    Array.isArray(filterValue) ? filterValue.length > 0 : !!filterValue,
  );
}
